import React, { useCallback } from "react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { Dialog, Button } from "@activecollab/components";
import { Formik } from "formik";
import PropTypes from "prop-types";
import { keyCodes } from "../../../utils/key_codes.jsx";
import { InputWithSelectedText } from "../../Inputs/InputWithSelectedText.jsx";
import { useConversationContext } from "../context/index.jsx";

export const ConversationRenameForm = ({ onSubmit, onCancel }) => {
  const { t } = useTranslation();
  const ref = useRef(null);
  const { conversation, rename } = useConversationContext();
  let { name } = conversation ?? {};
  name = name ?? "";

  const handleSubmit = useCallback(
    (values) => {
      rename(values);
      typeof onSubmit === "function" && onSubmit(values);
    },
    [onSubmit, rename]
  );

  const handleKeyDown = useCallback((event) => {
    if (event.key === keyCodes.enter) {
      ref.current?.click();
    }
  }, []);

  return (
    <Formik
      initialValues={{ name }}
      onSubmit={handleSubmit}
    >
      {({ handleChange, handleBlur, values, isSubmitting, isValid, handleSubmit }) => (
        <>
          <Dialog.Title>{t("Group Name")}</Dialog.Title>
          <Dialog.ContentDivider />
          <Dialog.Content className="tw-py-5">
            <InputWithSelectedText
              name="name"
              className="tw-w-full tw-h-10"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.name}
              autoFocus
              placeholder={t("Group Name")}
              onKeyDown={handleKeyDown}
            />
          </Dialog.Content>
          <Dialog.ContentDivider />
          <Dialog.Actions>
            <Button
              ref={ref}
              type="submit"
              disabled={isSubmitting || !isValid}
              variant="primary"
              className="tw-mr-3"
              onClick={handleSubmit}
            >
              {t("Save")}
            </Button>
            <Button
              type="button"
              onClick={onCancel}
              variant="secondary"
              disabled={isSubmitting}
            >
              {t("Cancel")}
            </Button>
          </Dialog.Actions>
        </>
      )}
    </Formik>
  );
};

ConversationRenameForm.propTypes = {
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
};
